import { render, staticRenderFns } from "./rms-objects-history-tab.vue?vue&type=template&id=54b83276&scoped=true"
import script from "./rms-objects-history-tab.vue?vue&type=script&lang=js"
export * from "./rms-objects-history-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b83276",
  null
  
)

export default component.exports